import { ResponseMap } from '@/shared/libs';

const logout = (subscriber) => {
  if (subscriber.isLogged) {
    subscriber.isFetched = false;
    subscriber.unbind();
    subscriber.reset();
    subscriber.emit('sync', '', subscriber);
  }
};

const subscriberError = (code, subscriber) => {
  switch (code) {
    case ResponseMap.AUTHENTICATION_REQUIRED:
    case ResponseMap.HTTP_SESSION_EXPIRED:
    case ResponseMap.HTTP_SESSION_REFRESH_TOKEN_FAILED:
      logout(subscriber);
      break;
    case ResponseMap.SUBSCRIBER_TERMS_NOT_ACCEPTED:
      break;
  }
};

export default subscriberError;
